<div
  class="towers-area--item"
  [class.default-style]="state() === 'Default'"
  [class.win-style]="state() === 'Win'"
  [class.opacity-effect]="state() === 'Win' && !picked()"
  [class.lose-style]="state() === 'Lose'"
  [class.extra-lose-style]="state() === 'ExtraLose'"
>
  @if (state() === 'Win' || state() === 'Lose') {
  <p
    class="towers-area--item__typography"
    [class.red]="state() === 'Lose'"
    [class.yellow]="state() === 'Win'"
  >
    <app-balance-icon
      [balance]="balance()"
      [color]="state() === 'Win' ? 'var(--yellow)' : 'var(--red)'"
    />
    {{ multiplier() | number : "1.2-2" }}
  </p>
  } @if (state() === 'Default') {
  <img
    class="grayscale-effect"
    src="assets/images/core/tf2-logo-hex.png"
    alt="tf2hunt.com"
  />
  } @if (state() === 'Win') {
  <img
    class="win-style--dots"
    src="assets/old-images/towers/dots-bg.svg"
    alt="dots images"
  />
  } @if (state() === 'Win') {
  <img
    class="win-style--tf2"
    src="assets/images/core/tf2-logo-hex.png"
    alt="tf2hunt.com"
  />
  } @if (state() === 'ExtraLose') {
  <img
    class="extra-lose-style--dots"
    src="assets/old-images/towers/extra-lose-dots.svg"
  />
  } @if (state() === 'ExtraLose') {
  <img
    class="extra-lose-style--rocket"
    src="assets/old-images/towers/lose-rocket.png"
  />
  }
</div>
